<div class="form-container d-flex flex-column position-relative">
    <form [formGroup]="form">
        <div class="input-container pb-0">
            <label class="text-label mb-2">{{ "pt.edp.edponline.request.operations.energetic.certification" | translate
                }}</label>

            <div class="radio-wrapper w-100 d-flex flex-row" formGroupName="energeticCertification">
                <label for="response-1" class="custom-radio-button-label">
                    <input id="response-1" type="radio" value="S" formControlName="response"
                        class="custom-radio-button-input" />
                    <span class="custom-radio-button-mark"></span>
                    <span>
                        {{ 'pt.edp.edponline.request.operations.energetic.certification.yes' | translate }}
                    </span>
                </label>

                <label for="response-2" class="custom-radio-button-label">
                    <input id="response-2" type="radio" value="N" formControlName="response"
                        class="custom-radio-button-input" />
                    <span class="custom-radio-button-mark"></span>
                    <span>
                        {{ 'pt.edp.edponline.request.operations.energetic.certification.no' | translate }}
                    </span>
                </label>
            </div>

            <div class="mt-3" *ngIf="!!response">
                <span class="title">
                    {{"pt.edp.edponline.request.operations.energetic.certification.docs" | translate}}
                </span>
                <ul>
                    <li>{{"pt.edp.edponline.request.operations.energetic.certification.doc1"| translate}}</li>
                    <li>{{"pt.edp.edponline.request.operations.energetic.certification.doc2"| translate}}</li>
                    <li *ngIf="response === 'N'">
                        {{"pt.edp.edponline.request.operations.energetic.certification.doc3"| translate}}
                    </li>
                    <li *ngIf="response === 'N'">
                        {{"pt.edp.edponline.request.operations.energetic.certification.doc4"| translate}}
                    </li>
                </ul>
            </div>
        </div>
    </form>

    <ng-container *ngTemplateOutlet="filesTemplate"></ng-container>
</div>

<ng-template #filesTemplate>
    <ng-container *ngIf="!!response">
        <div class="files">
            <ng-container *ngFor="let item of valuesFileToSet">
                <div [ngClass]="{ 'd-none': !!item.conditionResponse && item.conditionResponse !== response }">
                    <span class="subtitle mb-2">
                        {{ item.label | translate }}
                    </span>
                    <edp-drag-drop-files-upload (uploaded)="onUploadFile($event)" [maxFileSizeMB]="5"
                        [filesMessageLabel]="'pt.edp.edponline.third_step.enable_attach' | translate"
                        [fieldFileToToSet]="fieldFileToToSet" [valueFileToSet]="item.toSet">
                    </edp-drag-drop-files-upload>
                </div>
            </ng-container>
        </div>
    </ng-container>
</ng-template>